import { render, staticRenderFns } from "./AppServer.vue?vue&type=template&id=978a568e&scoped=true"
import script from "./AppServer.vue?vue&type=script&lang=js"
export * from "./AppServer.vue?vue&type=script&lang=js"
import style0 from "./AppServer.vue?vue&type=style&index=0&id=978a568e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "978a568e",
  null
  
)

export default component.exports